import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledSubtitleTypography = styled(Typography)`
  width: 80%;
  max-width: 1200px;
  font-size: ${({ theme }) => theme.spacing(3)};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-weight: ${({ theme }) => theme.typography.fontWeightLight};
`;
